import { render } from "./SportId.vue?vue&type=template&id=2ef38785&scoped=true"
import script from "./SportId.vue?vue&type=script&lang=js"
export * from "./SportId.vue?vue&type=script&lang=js"

import "./SportId.vue?vue&type=style&index=0&id=2ef38785&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef38785"]])

export default __exports__